import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const fwWingstopListLocationLossPreventionKpisConfigs = {
  discountCompsTotal: 'price',
  lossPreventionCompsCashOverOrShort: 'price',
  lossPreventionCheckCountVoids: 'number',
  lossPreventionCheckCountPercentVoids: 'percent',
} as const

const useFwWingstopListLocationLossPreventionKpis = buildMetricValuesHook({
  groupFilterType: 'store',
  metrics: {
    codes: [
      'discount_comps_total',
      'loss_prevention_comps_cash_over_or_short',
      'loss_prevention_check_count_voids',
      'loss_prevention_check_count_percent_voids',
    ],
  },
})

export default useFwWingstopListLocationLossPreventionKpis
